import React from 'react';

import { css, cx } from '@emotion/css';
import { Card, CardContent, CardHeader, Theme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useStyles } from '@/hooks/useStyles';
import {
  CurrentCarePlan,
  TelemonitoringInfo,
} from '@/pages/patient-settings/CurrentCarePlan';
import { Queries } from '@/queries/Queries';
import { RenewalButton } from '@/uiKit/molecules/RenewalButton';

export type TelemonitoringCardProps = {
  patientId: string;
  className?: string;
};

export const TelemonitoringCard: React.FC<TelemonitoringCardProps> = ({
  patientId,
  className,
}) => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);

  const carePlans = Queries.practitioner.useCarePlans(patientId);
  const me = Queries.user.usePractitionerMe({});

  const isNurse = me.qualification === 'nurse';

  return (
    <Card className={cx(styles.container, className)} elevation={0}>
      <CardHeader
        id="tls-title"
        title={t('pages.patientSettings.telemonitoring.title')}
      />
      <CardContent className={styles.content}>
        {carePlans.current_care_plan ? (
          <CurrentCarePlan
            carePlan={carePlans.current_care_plan}
            patientId={patientId}
          />
        ) : (
          <TelemonitoringInfo patientId={patientId} />
        )}
        {!isNurse ? (
          <div className={styles.alightRight}>
            <RenewalButton data-source="settings" patientId={patientId} />
          </div>
        ) : null}
      </CardContent>
    </Card>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(8)};
  `,
  content: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(8)};
  `,
  alightRight: css`
    align-self: flex-end;
  `,
});
